module.exports = __webpack_public_path__ + "static/media/Rectangle102.697050aa.svg";